/**
 * Helper function to make vertical slides using css transactions possible using the foundation toggler and some data-attributes
 *
 * CSS cant animate the height attribute, but the max-height. But: if the max-height is set to something real height
 * there is a delay, because you see the animation at the time its hit the "real height", to avoid this delay
 * we need to change max height to the real height for animations. That what the helpers does.
 *
 * Important: there is an motion ui function for doing some slide-in and out. This does not the same!
 *
 */

import $ from 'jquery';
import 'jquery.actual';

import App from 'libs/app';
import { transitionend } from 'foundation-sites/js/foundation.core.utils';

App.registerUiComponent("slide-vertical", () => {
    var $toggler = $("[data-toggler][data-animation='slide-vertical']");
    $toggler.each((index, item) => {
        // prevent multiple registrations on the same elements
        if (item?.sliderVerticalInitialized) {
            return;
        }
        item.sliderVerticalInitialized = true;

        $(item).on("on.zf.toggler", function (event) {
            // Avoid event trigger for nested elements
            event.stopPropagation();
            var $this = $(this);

            // Get the current and the target height
            var maxHeight = $this.attr("data-max-height");
            var currentHeight = $this.height();

            if(!maxHeight) {
                // Calculate the height of the element when openend
                $this.css({"transition": "unset", "max-height": ""});

                // Force a redraw
                $this.hide().show(0);

                maxHeight = $this.actual("outerHeight");
                $this.css({"max-height": currentHeight});
            }

            // At the end of the transition, clean up the inline styles
            $this.one(transitionend($this), () => {
                // Cancel our clean up if the item got closed during the transtion
                if(!$this.hasClass("open")) {
                    return;
                }

                // Temporary remove the transition to prevent
                // unwanted animations in Safari on Mac OS Safari
                $this.css({"max-height": "", "transition": "unset"});

                // Force a redraw
                $this.hide().show(0);

                // immediately remove our transition overwrite,
                // but do it after a timeout to trick Max OS X Safari
                setTimeout(function(){
                    $this.css({"transition": ""});
                },0);
            });

            // Force a redraw
            $this.hide().show(0);
            // Open -> max-height
            $this.css({"transition": "", "max-height": maxHeight + "px"});
        }).on("off.zf.toggler", function (event) {
            // Avoid event trigger for nested elements
            event.stopPropagation();

            // The open class got removed, close the element
            var $this = $(this);

            // Set the current height as max-height, avoid transitions here
            $this.css({"transition": "unset", "max-height": $this.height()+"px"});

            // Force a redraw
            $this.hide().show(0);

            // Close -> min-height as max-height
            $this.css({"transition": "", "max-height": $this.attr("data-min-height") + "px"});

            // At the end of the transition, clean up the inline styles
            $this.one(transitionend($this), function () {

                // Cancel our clean up if the item got opened during the transtion
                if($this.hasClass("open")) {
                    return;
                }

                // clean up the inline display style
                $this.css({"display": ""});
            });
        }).each(function (index, ele) {
            var $ele          = $(ele);
            var dataMaxHeight = $ele.attr("data-max-height");
            // The max height is maybe preset by other handler, so we just need to read it
            var maxHeight     = typeof dataMaxHeight == "undefined" ? undefined : parseInt(dataMaxHeight);
            // Sometimes the element should not close, only minimize
            var dataMinHeight = $ele.attr("data-min-height");
            var minHeight     = typeof dataMinHeight == "undefined" ? 0 : parseInt(dataMinHeight);

            var open          = $ele.hasClass("open");
            // Save the height to data attributes, so we can manipulate or just read without recalculation later
            if(dataMaxHeight) {
                $ele.attr("data-max-height", maxHeight);
            }
            $ele.attr("data-min-height", minHeight);

            // If open, set max height, if closed set min height
            if (!open) {
                // temporary remove the transition to prevent
                // unwanted animations in Safari on Mac OS
                $ele.css({"max-height": minHeight+"px", "transition": "unset"});
                setTimeout(function(){
                    // immediately remove our transition overwrite
                    $ele.css({"transition": ""});
                },0);
            }
        });
    });
});
